/// <amd-module name="Test/Client/RestClient/Test" />
/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   tfs\web\extensions\testmanagement\vss-test-web\common\client\test.genclient.json
 */

import { IVssPageContext, IVssRestClient, IVssRestClientOptions, RestClients } from "VSS/Platform/Context";
import { RestClientBase } from "VSS/Platform/RestClientBase";

import * as Test from "Test/common-util/Contracts/Test";

export interface ITestRestClient extends IVssRestClient {
    /**
     * Download a test result attachment by its ID.
     * 
     * @param project - Project ID or project name
     * @param runId - ID of the test run that contains the testCaseResultId.
     * @param testCaseResultId - ID of the test result whose attachment has to be downloaded.
     * @param attachmentId - ID of the test result attachment to be downloaded.
     */
    getTestResultAttachmentContent(project: string, runId: number, testCaseResultId: number, attachmentId: number): Promise<ArrayBuffer>;
    /**
     * Get list of test result attachments reference.
     * 
     * @param project - Project ID or project name
     * @param runId - ID of the test run that contains the result.
     * @param testCaseResultId - ID of the test result.
     */
    getTestResultAttachments(project: string, runId: number, testCaseResultId: number): Promise<Test.TestAttachment[]>;
    /**
     * Download a test sub result attachment
     * 
     * @param project - Project ID or project name
     * @param runId - ID of the test run that contains the result.
     * @param testCaseResultId - ID of the test results that contains sub result.
     * @param attachmentId - ID of the test result attachment to be downloaded
     * @param testSubResultId - ID of the test sub result whose attachment has to be downloaded
     */
    getTestSubResultAttachmentContent(project: string, runId: number, testCaseResultId: number, attachmentId: number, testSubResultId: number): Promise<ArrayBuffer>;
    /**
     * Get list of test sub result attachments
     * 
     * @param project - Project ID or project name
     * @param runId - ID of the test run that contains the result.
     * @param testCaseResultId - ID of the test results that contains sub result.
     * @param testSubResultId - ID of the test sub result whose attachment has to be downloaded
     */
    getTestSubResultAttachments(project: string, runId: number, testCaseResultId: number, testSubResultId: number): Promise<Test.TestAttachment[]>;
    /**
     * Download a test run attachment by its ID.
     * 
     * @param project - Project ID or project name
     * @param runId - ID of the test run whose attachment has to be downloaded.
     * @param attachmentId - ID of the test run attachment to be downloaded.
     */
    getTestRunAttachmentContent(project: string, runId: number, attachmentId: number): Promise<ArrayBuffer>;
    /**
     * Get list of test run attachments reference.
     * 
     * @param project - Project ID or project name
     * @param runId - ID of the test run.
     */
    getTestRunAttachments(project: string, runId: number): Promise<Test.TestAttachment[]>;
    /**
     * @param project - Project ID or project name
     * @param runId - 
     * @param testCaseResultId - 
     */
    getBugsLinkedToTestResult(project: string, runId: number, testCaseResultId: number): Promise<Test.WorkItemReference[]>;
    /**
     * Get code coverage data for a build.
     * 
     * @param project - Project ID or project name
     * @param buildId - ID of the build for which code coverage data needs to be fetched.
     * @param flags - Value of flags determine the level of code coverage details to be fetched. Flags are additive. Expected Values are 1 for Modules, 2 for Functions, 4 for BlockData.
     */
    getBuildCodeCoverage(project: string, buildId: number, flags: number): Promise<Test.BuildCoverage[]>;
    /**
     * Get Code Coverage Summary for Build.
     * 
     * @param project - Project ID or project name
     * @param buildId - ID of the build for which code coverage data needs to be fetched.
     * @param deltaBuildId - Delta Build id (optional)
     */
    getCodeCoverageSummary(project: string, buildId: number, deltaBuildId?: number): Promise<Test.CodeCoverageSummary>;
    /**
     * Get test points using query.
     * 
     * @param query - TestPointsQuery to get test points.
     * @param project - Project ID or project name
     * @param skip - Number of test points to skip..
     * @param top - Number of test points to return.
     */
    getPointsByQuery(query: Test.TestPointsQuery, project: string, skip?: number, top?: number): Promise<Test.TestPointsQuery>;
    /**
     * @param project - Project ID or project name
     * @param buildId - 
     * @param publishContext - 
     * @param groupBy - 
     * @param filter - 
     * @param orderby - 
     * @param shouldIncludeResults - 
     * @param queryRunSummaryForInProgress - 
     */
    getTestResultDetailsForBuild(project: string, buildId: number, publishContext?: string, groupBy?: string, filter?: string, orderby?: string, shouldIncludeResults?: boolean, queryRunSummaryForInProgress?: boolean): Promise<Test.TestResultsDetails>;
    /**
     * @param project - Project ID or project name
     * @param releaseId - 
     * @param releaseEnvId - 
     * @param publishContext - 
     * @param groupBy - 
     * @param filter - 
     * @param orderby - 
     * @param shouldIncludeResults - 
     * @param queryRunSummaryForInProgress - 
     */
    getTestResultDetailsForRelease(project: string, releaseId: number, releaseEnvId: number, publishContext?: string, groupBy?: string, filter?: string, orderby?: string, shouldIncludeResults?: boolean, queryRunSummaryForInProgress?: boolean): Promise<Test.TestResultsDetails>;
    /**
     * Get a test result for a test run.
     * 
     * @param project - Project ID or project name
     * @param runId - Test run ID of a test result to fetch.
     * @param testCaseResultId - Test result ID.
     * @param detailsToInclude - Details to include with test results. Default is None. Other values are Iterations, WorkItems and SubResults.
     */
    getTestResultById(project: string, runId: number, testCaseResultId: number, detailsToInclude?: Test.ResultDetails): Promise<Test.TestCaseResult>;
    /**
     * This API will return results by Ids with fields specified/trend for particular automated test method. We are still improving this API and have not finalized proper signature and contract.
     * 
     * @param query - 
     * @param project - Project ID or project name
     */
    getTestResultsByQuery(query: Test.TestResultsQuery, project: string): Promise<Test.TestResultsQuery>;
    /**
     * @param project - Project ID or project name
     * @param buildId - 
     * @param publishContext - 
     * @param includeFailureDetails - 
     * @param buildToCompare - 
     */
    queryTestResultsReportForBuild(project: string, buildId: number, publishContext?: string, includeFailureDetails?: boolean, buildToCompare?: Test.BuildReference): Promise<Test.TestResultSummary>;
    /**
     * Create new test run.
     * 
     * @param testRun - Run details RunCreateModel
     * @param project - Project ID or project name
     */
    createTestRun(testRun: Test.RunCreateModel, project: string): Promise<Test.TestRun>;
    /**
     * Get a test run by its ID.
     * 
     * @param project - Project ID or project name
     * @param runId - ID of the run to get.
     * @param includeDetails - Default value is true. It includes details like run statistics, release, build, test environment, post process state, and more.
     */
    getTestRunById(project: string, runId: number, includeDetails?: boolean): Promise<Test.TestRun>;
    /**
     * Add test cases to suite.
     * 
     * @param project - Project ID or project name
     * @param planId - ID of the test plan that contains the suite.
     * @param suiteId - ID of the test suite to which the test cases must be added.
     * @param testCaseIds - IDs of the test cases to add to the suite. Ids are specified in comma separated format.
     */
    addTestCasesToSuite(project: string, planId: number, suiteId: number, testCaseIds: string): Promise<Test.SuiteTestCase[]>;
    /**
     * Get history of a test method using TestHistoryQuery
     * 
     * @param filter - TestHistoryQuery to get history
     * @param project - Project ID or project name
     */
    queryTestHistory(filter: Test.TestHistoryQuery, project: string): Promise<Test.TestHistoryQuery>;
    /**
     * @param testSettings - 
     * @param project - Project ID or project name
     */
    createTestSettings(testSettings: Test.TestSettings, project: string): Promise<number>;
    /**
     * @param project - Project ID or project name
     * @param testName - 
     * @param workItemId - 
     */
    deleteTestMethodToWorkItemLink(project: string, testName: string, workItemId: number): Promise<boolean>;
    /**
     * @param project - Project ID or project name
     * @param testName - 
     */
    queryTestMethodLinkedWorkItems(project: string, testName: string): Promise<Test.TestToWorkItemLinks>;
    /**
     * @param project - Project ID or project name
     * @param workItemCategory - 
     * @param automatedTestName - 
     * @param testCaseId - 
     * @param maxCompleteDate - 
     * @param days - 
     * @param workItemCount - 
     */
    queryTestResultWorkItems(project: string, workItemCategory: string, automatedTestName?: string, testCaseId?: number, maxCompleteDate?: Date, days?: number, workItemCount?: number): Promise<Test.WorkItemReference[]>;
}

class TestRestClient extends RestClientBase implements ITestRestClient {
    constructor(options: IVssRestClientOptions) {
        super(options);
    }

    /**
     * Download a test result attachment by its ID.
     * 
     * @param project - Project ID or project name
     * @param runId - ID of the test run that contains the testCaseResultId.
     * @param testCaseResultId - ID of the test result whose attachment has to be downloaded.
     * @param attachmentId - ID of the test result attachment to be downloaded.
     */
    public async getTestResultAttachmentContent(
        project: string,
        runId: number,
        testCaseResultId: number,
        attachmentId: number
        ): Promise<ArrayBuffer> {

        return this.beginRequest<ArrayBuffer>({
            apiVersion: "5.1-preview.1",
            httpResponseType: "application/octet-stream",
            routeTemplate: "{project}/_apis/test/Runs/{runId}/Results/{testCaseResultId}/Attachments/{attachmentId}",
            routeValues: {
                project: project,
                runId: runId,
                testCaseResultId: testCaseResultId,
                attachmentId: attachmentId
            }
        });
    }

    /**
     * Get list of test result attachments reference.
     * 
     * @param project - Project ID or project name
     * @param runId - ID of the test run that contains the result.
     * @param testCaseResultId - ID of the test result.
     */
    public async getTestResultAttachments(
        project: string,
        runId: number,
        testCaseResultId: number
        ): Promise<Test.TestAttachment[]> {

        return this.beginRequest<Test.TestAttachment[]>({
            apiVersion: "5.1-preview.1",
            routeTemplate: "{project}/_apis/test/Runs/{runId}/Results/{testCaseResultId}/Attachments/{attachmentId}",
            routeValues: {
                project: project,
                runId: runId,
                testCaseResultId: testCaseResultId
            }
        });
    }

    /**
     * Download a test sub result attachment
     * 
     * @param project - Project ID or project name
     * @param runId - ID of the test run that contains the result.
     * @param testCaseResultId - ID of the test results that contains sub result.
     * @param attachmentId - ID of the test result attachment to be downloaded
     * @param testSubResultId - ID of the test sub result whose attachment has to be downloaded
     */
    public async getTestSubResultAttachmentContent(
        project: string,
        runId: number,
        testCaseResultId: number,
        attachmentId: number,
        testSubResultId: number
        ): Promise<ArrayBuffer> {

        const queryValues: any = {
            testSubResultId: testSubResultId
        };

        return this.beginRequest<ArrayBuffer>({
            apiVersion: "5.1-preview.1",
            httpResponseType: "application/octet-stream",
            routeTemplate: "{project}/_apis/test/Runs/{runId}/Results/{testCaseResultId}/Attachments/{attachmentId}",
            routeValues: {
                project: project,
                runId: runId,
                testCaseResultId: testCaseResultId,
                attachmentId: attachmentId
            },
            queryParams: queryValues
        });
    }

    /**
     * Get list of test sub result attachments
     * 
     * @param project - Project ID or project name
     * @param runId - ID of the test run that contains the result.
     * @param testCaseResultId - ID of the test results that contains sub result.
     * @param testSubResultId - ID of the test sub result whose attachment has to be downloaded
     */
    public async getTestSubResultAttachments(
        project: string,
        runId: number,
        testCaseResultId: number,
        testSubResultId: number
        ): Promise<Test.TestAttachment[]> {

        const queryValues: any = {
            testSubResultId: testSubResultId
        };

        return this.beginRequest<Test.TestAttachment[]>({
            apiVersion: "5.1-preview.1",
            routeTemplate: "{project}/_apis/test/Runs/{runId}/Results/{testCaseResultId}/Attachments/{attachmentId}",
            routeValues: {
                project: project,
                runId: runId,
                testCaseResultId: testCaseResultId
            },
            queryParams: queryValues
        });
    }

    /**
     * Download a test run attachment by its ID.
     * 
     * @param project - Project ID or project name
     * @param runId - ID of the test run whose attachment has to be downloaded.
     * @param attachmentId - ID of the test run attachment to be downloaded.
     */
    public async getTestRunAttachmentContent(
        project: string,
        runId: number,
        attachmentId: number
        ): Promise<ArrayBuffer> {

        return this.beginRequest<ArrayBuffer>({
            apiVersion: "5.1-preview.1",
            httpResponseType: "application/octet-stream",
            routeTemplate: "{project}/_apis/test/Runs/{runId}/Attachments/{attachmentId}",
            routeValues: {
                project: project,
                runId: runId,
                attachmentId: attachmentId
            }
        });
    }

    /**
     * Get list of test run attachments reference.
     * 
     * @param project - Project ID or project name
     * @param runId - ID of the test run.
     */
    public async getTestRunAttachments(
        project: string,
        runId: number
        ): Promise<Test.TestAttachment[]> {

        return this.beginRequest<Test.TestAttachment[]>({
            apiVersion: "5.1-preview.1",
            routeTemplate: "{project}/_apis/test/Runs/{runId}/Attachments/{attachmentId}",
            routeValues: {
                project: project,
                runId: runId
            }
        });
    }

    /**
     * @param project - Project ID or project name
     * @param runId - 
     * @param testCaseResultId - 
     */
    public async getBugsLinkedToTestResult(
        project: string,
        runId: number,
        testCaseResultId: number
        ): Promise<Test.WorkItemReference[]> {

        return this.beginRequest<Test.WorkItemReference[]>({
            apiVersion: "5.1-preview.1",
            routeTemplate: "{project}/_apis/test/Runs/{runId}/Results/{testCaseResultId}/Bugs",
            routeValues: {
                project: project,
                runId: runId,
                testCaseResultId: testCaseResultId
            }
        });
    }

    /**
     * Get code coverage data for a build.
     * 
     * @param project - Project ID or project name
     * @param buildId - ID of the build for which code coverage data needs to be fetched.
     * @param flags - Value of flags determine the level of code coverage details to be fetched. Flags are additive. Expected Values are 1 for Modules, 2 for Functions, 4 for BlockData.
     */
    public async getBuildCodeCoverage(
        project: string,
        buildId: number,
        flags: number
        ): Promise<Test.BuildCoverage[]> {

        const queryValues: any = {
            buildId: buildId,
            flags: flags
        };

        return this.beginRequest<Test.BuildCoverage[]>({
            apiVersion: "5.1-preview.1",
            routeTemplate: "{project}/_apis/test/CodeCoverage",
            routeValues: {
                project: project
            },
            queryParams: queryValues
        });
    }

    /**
     * Get Code Coverage Summary for Build.
     * 
     * @param project - Project ID or project name
     * @param buildId - ID of the build for which code coverage data needs to be fetched.
     * @param deltaBuildId - Delta Build id (optional)
     */
    public async getCodeCoverageSummary(
        project: string,
        buildId: number,
        deltaBuildId?: number
        ): Promise<Test.CodeCoverageSummary> {

        const queryValues: any = {
            buildId: buildId,
            deltaBuildId: deltaBuildId
        };

        return this.beginRequest<Test.CodeCoverageSummary>({
            apiVersion: "5.1-preview.1",
            routeTemplate: "{project}/_apis/test/CodeCoverage",
            routeValues: {
                project: project
            },
            queryParams: queryValues
        });
    }

    /**
     * Get test points using query.
     * 
     * @param query - TestPointsQuery to get test points.
     * @param project - Project ID or project name
     * @param skip - Number of test points to skip..
     * @param top - Number of test points to return.
     */
    public async getPointsByQuery(
        query: Test.TestPointsQuery,
        project: string,
        skip?: number,
        top?: number
        ): Promise<Test.TestPointsQuery> {

        const queryValues: any = {
            '$skip': skip,
            '$top': top
        };

        return this.beginRequest<Test.TestPointsQuery>({
            apiVersion: "5.1-preview.2",
            method: "POST",
            routeTemplate: "{project}/_apis/test/Points",
            routeValues: {
                project: project
            },
            queryParams: queryValues,
            body: query
        });
    }

    /**
     * @param project - Project ID or project name
     * @param buildId - 
     * @param publishContext - 
     * @param groupBy - 
     * @param filter - 
     * @param orderby - 
     * @param shouldIncludeResults - 
     * @param queryRunSummaryForInProgress - 
     */
    public async getTestResultDetailsForBuild(
        project: string,
        buildId: number,
        publishContext?: string,
        groupBy?: string,
        filter?: string,
        orderby?: string,
        shouldIncludeResults?: boolean,
        queryRunSummaryForInProgress?: boolean
        ): Promise<Test.TestResultsDetails> {

        const queryValues: any = {
            buildId: buildId,
            publishContext: publishContext,
            groupBy: groupBy,
            '$filter': filter,
            '$orderby': orderby,
            shouldIncludeResults: shouldIncludeResults,
            queryRunSummaryForInProgress: queryRunSummaryForInProgress
        };

        return this.beginRequest<Test.TestResultsDetails>({
            apiVersion: "5.1-preview.2",
            routeTemplate: "{project}/_apis/test/ResultDetailsByBuild",
            routeValues: {
                project: project
            },
            queryParams: queryValues
        });
    }

    /**
     * @param project - Project ID or project name
     * @param releaseId - 
     * @param releaseEnvId - 
     * @param publishContext - 
     * @param groupBy - 
     * @param filter - 
     * @param orderby - 
     * @param shouldIncludeResults - 
     * @param queryRunSummaryForInProgress - 
     */
    public async getTestResultDetailsForRelease(
        project: string,
        releaseId: number,
        releaseEnvId: number,
        publishContext?: string,
        groupBy?: string,
        filter?: string,
        orderby?: string,
        shouldIncludeResults?: boolean,
        queryRunSummaryForInProgress?: boolean
        ): Promise<Test.TestResultsDetails> {

        const queryValues: any = {
            releaseId: releaseId,
            releaseEnvId: releaseEnvId,
            publishContext: publishContext,
            groupBy: groupBy,
            '$filter': filter,
            '$orderby': orderby,
            shouldIncludeResults: shouldIncludeResults,
            queryRunSummaryForInProgress: queryRunSummaryForInProgress
        };

        return this.beginRequest<Test.TestResultsDetails>({
            apiVersion: "5.1-preview.2",
            routeTemplate: "{project}/_apis/test/ResultDetailsByRelease",
            routeValues: {
                project: project
            },
            queryParams: queryValues
        });
    }

    /**
     * Get a test result for a test run.
     * 
     * @param project - Project ID or project name
     * @param runId - Test run ID of a test result to fetch.
     * @param testCaseResultId - Test result ID.
     * @param detailsToInclude - Details to include with test results. Default is None. Other values are Iterations, WorkItems and SubResults.
     */
    public async getTestResultById(
        project: string,
        runId: number,
        testCaseResultId: number,
        detailsToInclude?: Test.ResultDetails
        ): Promise<Test.TestCaseResult> {

        const queryValues: any = {
            detailsToInclude: detailsToInclude
        };

        return this.beginRequest<Test.TestCaseResult>({
            apiVersion: "5.1-preview.6",
            routeTemplate: "{project}/_apis/test/Runs/{runId}/Results/{testCaseResultId}",
            routeValues: {
                project: project,
                runId: runId,
                testCaseResultId: testCaseResultId
            },
            queryParams: queryValues
        });
    }

    /**
     * This API will return results by Ids with fields specified/trend for particular automated test method. We are still improving this API and have not finalized proper signature and contract.
     * 
     * @param query - 
     * @param project - Project ID or project name
     */
    public async getTestResultsByQuery(
        query: Test.TestResultsQuery,
        project: string
        ): Promise<Test.TestResultsQuery> {

        return this.beginRequest<Test.TestResultsQuery>({
            apiVersion: "5.1-preview.6",
            method: "POST",
            routeTemplate: "{project}/_apis/test/Results",
            routeValues: {
                project: project
            },
            body: query
        });
    }

    /**
     * @param project - Project ID or project name
     * @param buildId - 
     * @param publishContext - 
     * @param includeFailureDetails - 
     * @param buildToCompare - 
     */
    public async queryTestResultsReportForBuild(
        project: string,
        buildId: number,
        publishContext?: string,
        includeFailureDetails?: boolean,
        buildToCompare?: Test.BuildReference
        ): Promise<Test.TestResultSummary> {

        const queryValues: any = {
            buildId: buildId,
            publishContext: publishContext,
            includeFailureDetails: includeFailureDetails,
            buildToCompare: buildToCompare
        };

        return this.beginRequest<Test.TestResultSummary>({
            apiVersion: "5.1-preview.3",
            routeTemplate: "{project}/_apis/test/ResultSummaryByBuild",
            routeValues: {
                project: project
            },
            queryParams: queryValues
        });
    }

    /**
     * Create new test run.
     * 
     * @param testRun - Run details RunCreateModel
     * @param project - Project ID or project name
     */
    public async createTestRun(
        testRun: Test.RunCreateModel,
        project: string
        ): Promise<Test.TestRun> {

        return this.beginRequest<Test.TestRun>({
            apiVersion: "5.1-preview.3",
            method: "POST",
            routeTemplate: "{project}/_apis/test/Runs/{runId}",
            routeValues: {
                project: project
            },
            body: testRun
        });
    }

    /**
     * Get a test run by its ID.
     * 
     * @param project - Project ID or project name
     * @param runId - ID of the run to get.
     * @param includeDetails - Default value is true. It includes details like run statistics, release, build, test environment, post process state, and more.
     */
    public async getTestRunById(
        project: string,
        runId: number,
        includeDetails?: boolean
        ): Promise<Test.TestRun> {

        const queryValues: any = {
            includeDetails: includeDetails
        };

        return this.beginRequest<Test.TestRun>({
            apiVersion: "5.1-preview.3",
            routeTemplate: "{project}/_apis/test/Runs/{runId}",
            routeValues: {
                project: project,
                runId: runId
            },
            queryParams: queryValues
        });
    }

    /**
     * Add test cases to suite.
     * 
     * @param project - Project ID or project name
     * @param planId - ID of the test plan that contains the suite.
     * @param suiteId - ID of the test suite to which the test cases must be added.
     * @param testCaseIds - IDs of the test cases to add to the suite. Ids are specified in comma separated format.
     */
    public async addTestCasesToSuite(
        project: string,
        planId: number,
        suiteId: number,
        testCaseIds: string
        ): Promise<Test.SuiteTestCase[]> {

        return this.beginRequest<Test.SuiteTestCase[]>({
            apiVersion: "5.1-preview.3",
            method: "POST",
            routeTemplate: "{project}/_apis/test/Plans/{planId}/Suites/{suiteId}/{action}/{testCaseIds}",
            routeValues: {
                project: project,
                planId: planId,
                suiteId: suiteId,
                testCaseIds: testCaseIds,
                action: "TestCases"
            }
        });
    }

    /**
     * Get history of a test method using TestHistoryQuery
     * 
     * @param filter - TestHistoryQuery to get history
     * @param project - Project ID or project name
     */
    public async queryTestHistory(
        filter: Test.TestHistoryQuery,
        project: string
        ): Promise<Test.TestHistoryQuery> {

        return this.beginRequest<Test.TestHistoryQuery>({
            apiVersion: "5.1-preview.2",
            method: "POST",
            routeTemplate: "{project}/_apis/test/Results/TestHistory",
            routeValues: {
                project: project
            },
            body: filter
        });
    }

    /**
     * @param testSettings - 
     * @param project - Project ID or project name
     */
    public async createTestSettings(
        testSettings: Test.TestSettings,
        project: string
        ): Promise<number> {

        return this.beginRequest<number>({
            apiVersion: "5.1-preview.1",
            method: "POST",
            routeTemplate: "{project}/_apis/test/TestSettings/{testSettingsId}",
            routeValues: {
                project: project
            },
            body: testSettings
        });
    }

    /**
     * @param project - Project ID or project name
     * @param testName - 
     * @param workItemId - 
     */
    public async deleteTestMethodToWorkItemLink(
        project: string,
        testName: string,
        workItemId: number
        ): Promise<boolean> {

        const queryValues: any = {
            testName: testName,
            workItemId: workItemId
        };

        return this.beginRequest<boolean>({
            apiVersion: "5.1-preview.1",
            method: "DELETE",
            routeTemplate: "{project}/_apis/test/TestMethods/{testName}/WorkItems/{workItemId}",
            routeValues: {
                project: project
            },
            queryParams: queryValues
        });
    }

    /**
     * @param project - Project ID or project name
     * @param testName - 
     */
    public async queryTestMethodLinkedWorkItems(
        project: string,
        testName: string
        ): Promise<Test.TestToWorkItemLinks> {

        const queryValues: any = {
            testName: testName
        };

        return this.beginRequest<Test.TestToWorkItemLinks>({
            apiVersion: "5.1-preview.1",
            method: "POST",
            routeTemplate: "{project}/_apis/test/TestMethods/{testName}/WorkItems/{workItemId}",
            routeValues: {
                project: project
            },
            queryParams: queryValues
        });
    }

    /**
     * @param project - Project ID or project name
     * @param workItemCategory - 
     * @param automatedTestName - 
     * @param testCaseId - 
     * @param maxCompleteDate - 
     * @param days - 
     * @param workItemCount - 
     */
    public async queryTestResultWorkItems(
        project: string,
        workItemCategory: string,
        automatedTestName?: string,
        testCaseId?: number,
        maxCompleteDate?: Date,
        days?: number,
        workItemCount?: number
        ): Promise<Test.WorkItemReference[]> {

        const queryValues: any = {
            workItemCategory: workItemCategory,
            automatedTestName: automatedTestName,
            testCaseId: testCaseId,
            maxCompleteDate: maxCompleteDate,
            days: days,
            '$workItemCount': workItemCount
        };

        return this.beginRequest<Test.WorkItemReference[]>({
            apiVersion: "5.1-preview.1",
            routeTemplate: "{project}/_apis/test/Results/WorkItems",
            routeValues: {
                project: project
            },
            queryParams: queryValues
        });
    }

}

export const TestClientName = "ITestRestClient";

export function getTestClient(pageContext: IVssPageContext, options?: IVssRestClientOptions): ITestRestClient {
    return pageContext.getRestClient<ITestRestClient>(TestClientName, options);
}

RestClients.add(TestClientName, { 
    factory: TestRestClient,
    options: {
        resourceAreaId: "c2aa639c-3ccc-4740-b3b6-ce2a1e1d984e",
        serviceInstanceType: "00025394-6065-48ca-87d9-7f5672854ef7"
    }
});
